<template>
    <div  class="wrap">
		<el-dialog
		  title="编辑文章内容"
		  :visible.sync="articleEditDialogVisible"
		  width="60%">
			<div class="top-button">
				<el-button   type="primary" plain size="mini" @click="switchType">切换为{{switchText}}</el-button>
			</div>
			<div class="content-html" v-resize="resize">
				<el-upload v-show="false" class="avatar-uploader" action="#" :show-file-list="false" :http-request="uploadHttpRequest" >
				</el-upload>
				<quill-editor v-show="isCheck" ref="myQuillEditor" v-model="transHtml" :style="'height:' + height" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)" />
				<mavon-editor class="showmav" ref="md" v-show="!isCheck" v-model="mContent"  />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitInfo">确 定</el-button>
			</span>
		</el-dialog>
       
    </div>
</template>
<script>
import {
    Base64
} from 'js-base64'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import turndown from "turndown"; //html转markdown
import { baseImg } from "@/common/global.js";
// html显示（富文本插件）
import {
    quillEditor
} from "vue-quill-editor";
import {
    uploadDocImg,
    articleEntryPdf,
	articleEntryMd,
	editUpdateFile,
	editUpdateDocInfo
} from "@/network/mochaItom/index.js"
import {
    articeDetails
} from "@/network/content/artice";
// html的配置toolbar
const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ 'header': 1 }, { 'header': 2 }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],
    [{ 'indent': '-1' }, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }],
    [{ 'size': ['small', false, 'large', 'huge'] }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'font': [] }],
    [{ 'align': [] }],
    ['clean'],
    ['link', 'image', 'video']
];
//工具栏
// const mdtoolbarOptions = {
//     bold: true, // 粗体
//     italic: true, // 斜体
//     header: true, // 标题
//     underline: true, // 下划线
//     strikethrough: true, // 中划线
//     mark: true, // 标记
//     superscript: true, // 上角标
//     subscript: true, // 下角标
//     quote: true, // 引用
//     ol: true, // 有序列表
//     ul: true, // 无序列表
//     link: true, // 链接
//     imagelink: true, // 图片链接
//     code: true, // code
//     table: true, // 表格
//     fullscreen: true, // 全屏编辑
//     readmodel: true, // 沉浸式阅读
//     htmlcode: true, // 展示html源码
//     help: true, // 帮助
//     undo: true, // 上一步
//     redo: true, // 下一步
//     trash: true, // 清空
//     save: true, // 保存（触发events中的save事件）
//     navigation: true, // 导航目录
//     alignleft: true, // 左对齐
//     aligncenter: true, // 居中
//     alignright: true, // 右对齐
//     subfield: true, // 单双栏模式
//     preview: true // 预览
// }

import common from '@/common/common.js';
export default {
    name: "articleEdit",
    components: {
        quillEditor,
    },
    data() {
        return {
			articleEditDialogVisible:false,
            isCheck: false,
            height: '',
            turndownService: null,
            editorOption: {
                placeholder: "编辑文章内容",
                modules: {
                    toolbar: {
                        container: toolbarOptions, // 工具栏
                        handlers: {
                            'image': (value) => {
                                if (value) {
                                    // 触发input框选择图片文件
                                    document.querySelector('.avatar-uploader input').click()
                                } else {
                                    this.quill.format('image', false);
                                }
                            }
                        }
                    }
                }
            },
            transHtml: "",
            imgType: 2, //1首图，2文章内部的图
            mContent: "",
			docId:""//文章id，修改的时候需要
        }
    },
    computed: {
        switchText() {
            return this.isCheck ? "markdown" : "富文本";
        },
    },
    filters: {
        imagesrc(src) {
           return baseImg + src;
        }
    },
    directives: { // 使用局部注册指令的方式
        resize: { // 指令的名称
            bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
                let width = '',
                    height = '';

                function isReize() {
                    const style = document.defaultView.getComputedStyle(el);
                    // console.log(style)
                    if (width !== style.width || height !== style.height) {
                        binding.value(style.height); // 关键
                    }
                    width = style.width;
                    height = style.height;
                }
                el.__vueSetInterval__ = setInterval(isReize, 300);
            },
            unbind(el) {
                clearInterval(el.__vueSetInterval__);
            }
        }
    },
	created() {
	    // html 转换 markdown 
	    const TurndownService = require("turndown").default;
	    this.turndownService = new TurndownService();
	},
    methods: {
        switchType() {
            this.isCheck = !this.isCheck;
            if (this.isCheck) {
                // markdown转html  this.$refs.md.d_render
                this.transHtml = this.$refs.md.d_render;
				console.log(this.transHtml)

            } else {
                // this.mContent = this.$refs.md.d_value
                this.mContent = this.turndownService.turndown(this.transHtml);
            }

        },
        uploadHttpRequest(param) { //上传图片
            const formData = new FormData();
            formData.append('file', param.file);
            formData.append('type', this.imgType);
            uploadDocImg(formData).then(res => {
                if (res.data.code == 200) {
                    let quill = this.$refs.myQuillEditor.quill;
                    let length = quill.getSelection().index;
                    // 插入图片  
                    quill.insertEmbed(length, 'image', res.data.data);
                    // 调整光标到最后
                    quill.setSelection(length + 1);
                    console.log('imgType')
                }
            })
        },
        // 编辑器
        resize(data) { // 当宽高变化时就会执行
            //执行某些操作
            let height = data.slice(0, data.length - 2) - 100 + "px"
            this.height = height;
        },
        // 编辑器的方法
        onEditorReady(quill) {
            console.log("editor ready!");
        },
        onEditorFocus(quill) {
            console.log("editor focus!");
        },
        onEditorChange({
            quill,
            html,
            text
        }) {
            // console.log('editor change!', quill, html, text);
            this.transHtml = html;
        },
        onEditorBlur(quill) {
            console.log("editor blur!", quill);
        },
        submitInfo() {
			let html;
			let md;
			let transHtmlStart =
				'<!DOCTYPE html><html><head><meta charset="utf-8" /><meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no" /></head><body>';
			let transHtmlEnd = '</body></html>'
            if (this.isCheck) {// html
            	md = this.turndownService.turndown(this.transHtml);
            	html = transHtmlStart + this.transHtml + transHtmlEnd;
            } else {// md
				html = transHtmlStart + this.$refs.md.d_render + transHtmlEnd;
            	md = this.mContent;
            }
			this.$emit('contentParams',{html:html,md:md});
			this.articleEditDialogVisible = false;
			
        },
	
    }
}
</script>
<style scoped="scoped" lang="scss">
.wrap,
.content-html,
.showhtml,
.showmav {
    height: 50vh;
}
.top-button{
	margin-bottom: 16px;
}
</style>
